"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _reactTextMask = _interopRequireDefault(require("react-text-mask"));

var _ramda = require("ramda");

var _reactPhoneInput = _interopRequireDefault(require("react-phone-input-2"));

var _ru = _interopRequireDefault(require("react-phone-input-2/lang/ru.json"));

var _withFieldWrapper = _interopRequireDefault(require("../hocs/withFieldWrapper"));

var _mask = require("../../utils/mask");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = {
  "formWrapper": "index__formWrapper",
  "formBtn": "index__formBtn",
  "formBtnCancel": "index__formBtnCancel",
  "formLink": "index__formLink",
  "withoutOpd": "index__withoutOpd",
  "formLabel": "index__formLabel",
  "formLabelRequired": "index__formLabelRequired",
  "formLabelOptional": "index__formLabelOptional",
  "formInput": "index__formInput",
  "formTextarea": "index__formTextarea",
  "formSection": "index__formSection",
  "formSectionRow": "index__formSectionRow",
  "formSectionBtn": "index__formSectionBtn",
  "error": "index__error",
  "compositeError": "index__compositeError",
  "fileInput": "index__fileInput",
  "fileControls": "index__fileControls",
  "formDateSelect": "index__formDateSelect",
  "formMoneySelect": "index__formMoneySelect",
  "amountField": "index__amountField",
  "currencyField": "index__currencyField",
  "imagePreview": "index__imagePreview",
  "dangerBtn": "index__dangerBtn",
  "dangerBtnDisabled": "index__dangerBtnDisabled",
  "fileList": "index__fileList",
  "fileItem": "index__fileItem",
  "downloadButton": "index__downloadButton",
  "downloadButtonDisabled": "index__downloadButtonDisabled",
  "fileButtonGroup": "index__fileButtonGroup",
  "timeIndicator": "index__timeIndicator",
  "modalButtonGroup": "index__modalButtonGroup"
};

var MaskedInput = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(MaskedInput, _Component);

  var _super = _createSuper(MaskedInput);

  function MaskedInput() {
    (0, _classCallCheck2["default"])(this, MaskedInput);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(MaskedInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$input = _this$props.input,
          value = _this$props$input.value,
          name = _this$props$input.name,
          _this$props$settings = _this$props.settings,
          _this$props$settings$ = _this$props$settings.keepCharPositions,
          keepCharPositions = _this$props$settings$ === void 0 ? false : _this$props$settings$,
          _this$props$settings$2 = _this$props$settings.guide,
          guide = _this$props$settings$2 === void 0 ? true : _this$props$settings$2,
          onChange = _this$props.onChange,
          mask = _this$props.mask,
          disabled = _this$props.disabled,
          placeholder = _this$props.placeholder;
      return /*#__PURE__*/_react["default"].createElement(_reactTextMask["default"], {
        id: name,
        disabled: disabled,
        className: "".concat(styles.formInput, " input"),
        value: value || '',
        onChange: onChange,
        mask: mask,
        placeholderChar: "\u2000",
        placeholder: placeholder,
        keepCharPositions: keepCharPositions,
        guide: guide
      });
    }
  }]);
  return MaskedInput;
}(_react.Component);

var languages = {
  et: 'ee',
  en: false
};
var PhoneInput = (0, _withFieldWrapper["default"])(function (props) {
  var _props$input = props.input,
      value = _props$input.value,
      name = _props$input.name,
      _onChange = props.onChange,
      disabled = props.disabled,
      placeholder = props.placeholder,
      language = props.language,
      languageOrigin = props.languageOrigin;
  return (0, _ramda.path)(['settings', 'international'], props) ? /*#__PURE__*/_react["default"].createElement(_reactPhoneInput["default"], {
    key: language,
    id: name,
    name: name,
    className: "".concat(styles.formInput, " input"),
    disabled: disabled,
    country: languages[languageOrigin || language] || languageOrigin || language,
    preferredCountries: ['ru', 'by', 'ua', 'kz', 'uz', 'tj', 'lv', 'lt', 'ee'],
    localization: language === 'ru' ? _ru["default"] : undefined,
    value: value,
    placeholder: placeholder,
    onChange: function onChange(value, country, e, formattedValue) {
      return _onChange(formattedValue);
    },
    preserveOrder: ['onlyCountries'],
    countryCodeEditable: false,
    masks: {
      tj: '(...) ..-..-..',
      uz: '...-...-...',
      lv: '(..) ..-..-..',
      lt: '(..) ..-..-..',
      ee: '(..) ......'
    }
  }) : /*#__PURE__*/_react["default"].createElement(MaskedInput, (0, _extends2["default"])({}, props, {
    mask: _mask.getPhoneMaskRU,
    showMask: true,
    placeholder: "+"
  }));
});
var _default = PhoneInput;
exports["default"] = _default;